<div class="modal fade" id="modalCalendar" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header position-relative border-bottom-0 pb-0">
                <h5 class="modal-title w-100 text-center m-0 fw-bold">
                    CHỌN THỜI GIAN
                </h5>

                <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                ></button>
            </div>

            <div class="modal-body d-flex justify-content-center align-items-center">
                <VueDatePicker
                        v-model="date"
                        inline
                        :enable-time-picker="false"
                        :min-date="new Date()"
                        :auto-apply="true"
                        @update:model-value="handleDate"
                />
            </div>
            <div class="modal-footer d-flex justify-content-center align-items-center">
                <button-add-component :label="labelConfirm" :width="'100%'" @click="confirmDate"></button-add-component>
            </div>
        </div>
    </div>
</div>
